import { render, staticRenderFns } from "./PermissionHistory.vue?vue&type=template&id=639bda72&scoped=true&"
import script from "./PermissionHistory.vue?vue&type=script&lang=js&"
export * from "./PermissionHistory.vue?vue&type=script&lang=js&"
import style0 from "./PermissionHistory.vue?vue&type=style&index=0&id=639bda72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639bda72",
  null
  
)

export default component.exports